import React from "react";
import { useNavigate } from "react-router-dom";
import V2Shell from "../../v2/V2Shell";

// The logged-in app frame (v2 is the only design since 2026-11-04).
const Dashboard = (props) => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    props.showAlert("Logged out successfully", "success");
    navigate("/login");
  };

  return <V2Shell onLogout={logout} />;
};

export default Dashboard;
